import { render, staticRenderFns } from "./MyPassword.vue?vue&type=template&id=4bfc821a&scoped=true&"
import script from "./MyPassword.vue?vue&type=script&async=true&lang=js&"
export * from "./MyPassword.vue?vue&type=script&async=true&lang=js&"
import style0 from "./MyPassword.vue?vue&type=style&index=0&id=4bfc821a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfc821a",
  null
  
)

export default component.exports